<template>
  <div>
  <b-alert
    :show="showModal"
    variant="info"
    class="p-4"
    dismissible
  >
    <h4 class="alert-heading mb-3 font-jumper">Pmt tv. szerinti kötelező ügyfélátvilágítás</h4>
    <div style="text-align: justify; text-justify: inter-word;" class="font-jumperlight">A pénzmosás és a terrorizmus finanszírozása megelőzéséről és megakadályozásáról szóló törvény szerint kötelező
      a speciális ügyfélátvilágítás.
      Ennek érdekében kérjük töltsd fel céged minden tulajdonosának személyi igazolvány másolatát.<br> Köszönjük
      együttműködésed!
    </div>

    <div v-if="multipleOwner" class="my-3">
      <label>Tulajdonosok száma:</label>
      <b-form-input
          class="w-50"
          v-model="numberOfOwners"
          placeholder="Tulajdonosok száma"
          v-mask="'###'"
      ></b-form-input>
    </div>

    <input
        type="file"
        ref="fileUploader"
        class="d-none"
        @change="(e) => {
          uploadToCompany(e.target.files[0]);
        }"
    />
    <div v-if="numberOfOwners < 10">
      <div v-for="(owner, index) in owners" :key="index" class="my-3">
        <label>Tulajdonos neve:</label>
        <div class="d-flex w-100">
          <div class="w-25">
            <b-form-input
                class="w-100"
                v-model="owner.name"
                :placeholder="(index + 1) + '. tulajdonos neve'"
            ></b-form-input>
          </div>
          <div class="d-flex">
            <div v-if="!owner.fileId1 || !owner.fileId2" style="cursor: pointer; margin-left: 6px; padding-left: 12px; padding-right: 12px; background-color: #b2ec5d; border-radius: 50%; width: 42px; height: 42px; text-align: center; line-height: 42px;" @click="() => {
                currentIndex = index;
                $refs.fileUploader.click();
              }">
              <svg style="width: 14px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 53 43 96 96 96H352c53 0 96-43 96-96V352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352z" fill="#2525734"/></svg>
            </div>

            <div class="d-flex mx-3">
              <template v-if="owner.fileId1">
                <div class="mt-2">
                  {{ owner.fileName1 }}
                </div>
                <div class="mt-2 ml-3 mr-4 text-danger" style="cursor: pointer" @click="() => {
                  owner.fileId1 = null;
                }">
                  <i class="fas fa-trash"></i>
                </div>
              </template>
              <template v-if="owner.fileId2">
                <div class="mt-1">
                  {{ owner.fileName2 }}
                </div>
                <div class="mt-1 mx-3 text-danger" style="cursor: pointer" @click="() => {
                  owner.fileId2 = null;
                }">
                  <i class="fas fa-trash"></i>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <b-button
          class="mt-3 mr-3"
          @click="() => showModal = false"
          variant="link"
      >Mégse
      </b-button>
      <b-button
          class="mt-3"
          variant="success"
          @click="saveData"
      >Mentés
      </b-button>
    </div>

    <div v-if="uploadInProgress" style="position: fixed; top: 0; left: 0; background-color: rgba(0, 0, 0, 0.7); backdrop-filter: blur(4px); width: 100vw; height: 100vh">
      <div class="text-white w-100 text-center" style="margin-top: 100px; font-size: 42px">Fájl feltölése folyamatban, kérlek várj!</div>
    </div>

    <div v-if="showTooMuchOwnerModal" style="position: fixed; top: 0; left: 0; background-color: rgba(0, 0, 0, 0.7); backdrop-filter: blur(4px); width: 100vw; height: 100vh">
      <div class="bg-white mx-auto" style="width: 1138px; margin-top: 100px; padding: 16px">
        <div>10-nél több tulajdonos esetén az adatok megadását email-ben kérjük. A teendőkkel kapcsolatban ügyféltámogatási csapatunk hamarosan felveszi veled a kapcsolatot. Megerősíted, hogy 10-nél több tulajdonos van a cégben?</div>
        <div class="d-flex justify-content-end">
            <b-button
                class="mt-3 mr-3"
                @click="() => showTooMuchOwnerModal = false"
            >Vissza
            </b-button>
            <b-button
                class="mt-3"
                variant="success"
                @click="requestHelp"
            >Igen
            </b-button>
        </div>
      </div>
    </div>
  </b-alert>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from "axios";
import {API2_URL} from "api-client";

export default {
  name: "OwnerIdentification",

  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },

  watch: {
    numberOfOwners: function (val) {
      let numVal = parseInt(val);
      if (isNaN(numVal)) {
        return;
      }

      this.updateNumberOfOwners(numVal);
    },
  },

  mounted() {
    this.loadData();
  },

  data() {
    return {
      showTooMuchOwnerModal: false,
      uploadInProgress: false,
      showModal: false,
      currentIndex: 0,
      multipleOwner: false,
      numberOfOwners: null,
      owners: [],
    };
  },

  methods: {
    loadData() {
      axios.get(API2_URL + `/company/${this.getActiveCompany.id}/is-owners-data-required`)
          .then((resp) => {
            this.multipleOwner = resp.data.multipleOwner;
            if (resp.data.required) {
              axios.get(API2_URL + `/company/${this.getActiveCompany.id}/owners`)
                  .then((resp) => {
                    this.owners = resp.data;
                    this.numberOfOwners = this.owners.length >= 1 ? this.owners.length : 1;

                    this.showModal = true;
                  })
                  .catch(error => {
                    this.$toast.error({
                      title: 'Hiba',
                      message: 'API hiba',
                    });
                    console.error(error);
                  });
            }
          })
          .catch(error => {
            this.$toast.error({
              title: 'Hiba',
              message: 'API hiba',
            });
            console.error(error);
          });
    },

    saveData() {
      if (this.owners.length > 9) {
        this.showTooMuchOwnerModal = true;
        return;
      }

      for (let owner of this.owners) {
        if (!owner.name || owner.name === '') {
          this.$toast.error({
            title: 'HIBA',
            message: 'Kérjük add meg a tulajdonosok nevét!',
          });
          return;
        }

        if (!owner.fileId1) {
          this.$toast.error({
            title: 'HIBA',
            message: 'Kérjük töltsd fel a tulajdonosok személyi igazolványát!',
          });
          return;
        }
      }

      axios.post(API2_URL + `/company/${this.getActiveCompany.id}/owners`, this.owners)
          .then(() => {
            this.$toast.success({
              title: 'Siker',
              message: 'Sikeres mentés',
            });
            this.showModal = false;
          })
          .catch(error => {
            this.$toast.error({
              title: 'Hiba',
              message: 'API hiba',
            });
            console.error(error);
          });
    },

    updateNumberOfOwners(numVal) {
      while (numVal !== this.owners.length) {
        if (numVal < this.owners.length) {
          this.owners.pop();
        } else {
          this.owners.push({
            name: '',
            fileId1: null,
            fileId2: null,
            fileName: ''
          });
        }
      }
    },

    uploadToCompany(file) {
      this.uploadInProgress = true;
      const formData = new FormData();
      formData.append('file', file);

      axios.post(API2_URL + "/company/" + this.getActiveCompany.id + "/upload-owner-identification", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then(response => {
            if (this.owners[this.currentIndex].fileId1) {
              this.owners[this.currentIndex].fileId2 = response.data.id;
              this.owners[this.currentIndex].fileName2 = file.name;
            } else {
              this.owners[this.currentIndex].fileId1 = response.data.id;
              this.owners[this.currentIndex].fileName1 = file.name;
            }
            this.uploadInProgress = false;
          })
          .catch(error => {
            this.$toast.error({
              title: 'Hiba',
              message: 'Fájl feltöltés hiba',
            });
            console.error(error);
            this.uploadInProgress = false;
          });
    },

    requestHelp() {
      axios.post(API2_URL + `/company/${this.getActiveCompany.id}/request-pmt-help`, { ownersAmount: this.numberOfOwners})
          .then(() => {
            this.showModal = false;
          })
          .catch(error => {
            this.$toast.error({
              title: 'Hiba',
              message: 'API hiba',
            });
            console.error(error);
          });
    }
  },
};
</script>

<style scoped>
.alert-info {
  background-color: #252734;
  color: white;
  border: none;
  border-radius: 32px;
}
</style>
